import React, { useState, useEffect, useMemo } from 'react';
import { TotalData, HoldingsTabKeyNames } from '../../index.type';
import ActivePie from '@/components/charts/ActivePie';
import { extractNumber } from '@/lib/utils';
interface IndustryDistributionProps {
  selectedMetrics: {
    industryDistribution?: boolean;
    [key: string]: boolean | undefined;
  };
  totalData: Pick<TotalData, HoldingsTabKeyNames>;
}

const IndustryDistribution: React.FC<IndustryDistributionProps> = ({
  selectedMetrics,
  totalData
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    industryDistribution?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  const handleCheckboxChange = (checked: boolean) => {
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      industryDistribution: checked
    }));
  };

  const [charsRightData, setCharsRightData] = useState([
    { label: '持仓基金数', value: 0, key: 'holding_fund_count', unit: '' },
    { label: '最大持仓基金', value: 0, key: 'largest_holding_fund', unit: '%' },
    { label: '持仓行业数', value: 0, key: 'holding_industry_count', unit: '' },
    {
      label: '最大行业比例',
      value: 0,
      key: 'largest_industry_ratio',
      unit: '%'
    }
  ]);

  const charsData = useMemo(() => {
    const data = charsRightData.map(item => ({
      label: item.label,
      value: totalData[item.key],
      key: item.key,
      unit: item.unit
    }));
    setCharsRightData(data);
    return [
      { name: '科技', value: 275, fill: '#5959EB' },
      { name: '金融', value: 200, fill: '#13C2C2' },
      { name: '消费', value: 187, fill: '#1677FF' },
      { name: '医药', value: 173, fill: '#FF7B52' },
      { name: '其他', value: 90, fill: '#F8467B' }
    ];
  }, [totalData]);

  return (
    <div className="my-4 rounded-lg border border-[#F0F0F0] p-3">
      {/* 标题和复选框 */}
      <div className="mb-4 flex items-center gap-2">
        <input
          type="checkbox"
          checked={currentSelectedMetrics.industryDistribution || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="h-4 w-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">行业分布</span>
      </div>
      {/* 图表和图例 */}
      <div className="flex flex-wrap items-center justify-start gap-6">
        {/* 饼图 */}
        <div className="relative h-[30vw] w-full min-[500px]:w-[50vw]">
          <ActivePie data={charsData} legendPosition="right" activeIndex={0} />
        </div>
        {/* 图例 */}
        <div className="flex flex-1 flex-col gap-2">
          {charsRightData.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between gap-2 rounded-[6px] bg-gradient-to-r from-[#EEEDFF] to-[#F6F7FF] p-[6px]"
            >
              <span className="text-sm text-[#1F1F1F]">{item.label}</span>
              <span className="text-[#1F1F1F]">
                <span className="text-lg font-semibold">
                  {extractNumber(item.value.toString())}
                </span>
                <span className="text-xs font-medium">{item.unit}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IndustryDistribution;
